<template>

<svg xmlns="http://www.w3.org/2000/svg"  viewBox="-11.5 780.5 24 24" >
<polygon points="3.06,789.75 0.5,787.34 -2.06,789.75 -2.06,793.53 -0.47,793.53 -0.47,794.9 -0.04,795.01 -0.26,797.92 
	-0.26,801.88 0.5,802.5 1.25,801.88 1.25,797.92 1.04,795.01 1.47,794.9 1.47,793.53 3.06,793.53 "/>
<path d="M6.89,791.47v-4.03H4.72v-4.94l-2.22,2.23l-1.98-1.98l-1.98,1.98l-2.22-2.23v4.94h-2.2v4.03c-1.04,1.41-1.04,3.33,0,4.73
	v4.03h3.97l1.18,1.18v-0.7l-2.45-2.45v-1.25l2.45,2.45v-0.7l-2.45-2.45v-1.24l2.46,2.46l0.01-0.01l0.05-0.63l-2.52-2.52v-4.96
	l3.7-3.7l3.73,3.73v4.93l-2.55,2.55l0.04,0.56l0.05,0.05l2.46-2.46v1.24l-2.48,2.48v0.66l0.02,0.02l2.46-2.46v1.22l-2.48,2.48v0.7
	l1.18-1.18H6.9v-4.03C7.94,794.8,7.93,792.88,6.89,791.47z M-5.4,787.94h1.71v1.26l-1.71,1.71V787.94z M-5.17,791.38l1.47-1.47v7.87
	l-1.47-1.47C-6.53,794.94-6.53,792.74-5.17,791.38z M-2.43,799.74h-2.98v-2.97L-2.43,799.74z M4.22,788.74l-3.73-3.73l-3.69,3.69v-5
	l1.73,1.73l1.98-1.98l1.98,1.98l1.73-1.73L4.22,788.74z M4.72,787.94H6.4v2.97l-1.68-1.68L4.72,787.94z M6.4,799.74H3.42l2.97-2.97
	V799.74z M6.16,796.3l-1.44,1.44v-7.8l1.44,1.44C7.5,792.73,7.49,794.93,6.16,796.3L6.16,796.3z"/>
</svg>

</template>